<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="优惠券名称:">
                    <el-input placeholder="请输入优惠券名称" v-model="queryParams.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="订单编号:">
                    <el-input placeholder="请输入订单编号" v-model="queryParams.ordersn" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户id:">
                    <el-input placeholder="请输入用户id" v-model="queryParams.uid" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="已使用" :value="2"></el-option>
                        <el-option label="未使用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-form :inline="true" class="demo-form-inline">
                <el-button type="primary" @click="giveCoupon()">发券</el-button>
            </el-form>
            <!-- 表格内容 -->
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable" style="margin-top:20px">
                <el-table-column prop="id" label="id" width="150" align="center"></el-table-column>
                <el-table-column prop="ordersn" label="订单编号" width="200" align="center"></el-table-column>
                <el-table-column prop="name" label="优惠券名称" align="center"></el-table-column>
                <el-table-column prop="uid" label="用户id" align="center" width="120"></el-table-column>
                <el-table-column prop="price" label="优惠券价格" width="100" align="center"></el-table-column>
                <el-table-column prop="full_price" label="满减金额" width="100" align="center"></el-table-column>
                <el-table-column prop="ctime" label="送券时间" width="170" align="center"></el-table-column>
                <el-table-column prop="utime" label="使用时间" width="170" align="center"></el-table-column>
                <el-table-column prop="state" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 1">未使用</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">已使用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <!-- <el-button v-if="scope.row.state === 2" type="text" class="red" >未使用</el-button> -->
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)" icon="el-icon-edit">已使用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
            <!-- 送券提示框 -->
            <el-dialog title="送券" :visible.sync="show" width="600px" class="dialog_box">
                <el-form ref="forms" :model="forms" label-width="100px" :rules="rules" label-position="left">
                    <el-form-item label="用户id " prop="uid">
                        <el-input v-model="forms.uid" placeholder="请输入用户id"></el-input>
                    </el-form-item>
                    <el-form-item label="优惠券id" prop="coupon_ids">
                        <el-input v-model="forms.coupon_ids" placeholder="请输入优惠券id,多id请用，分割"></el-input>
                        <el-button @click="addVisibles=true">选择优惠券</el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="show = false">取 消</el-button>
                    <el-button type="primary" @click="give">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 上线、下线提示框 -->
            <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
                <div class="del-dialog-cnt">{{ confirmContent }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirmVisible = false">取 消</el-button>
                    <el-button type="primary" @click="stateData">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <Discountcom :addVisible="addVisibles" :title="title" @toggleAdd="toggleAdd" @getAddGood="getAddGood" :state="discount_state" :pGoodsList="[]"></Discountcom>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import { deal } from '@/common/main';
import Discountcom from '@/components/Discountcom';
export default {
    components: {
        Breadcrumb,
        Pagination,
        Discountcom,
    },
    data() {
        return {
            discount_state: 2,
            show: false,
            addVisibles: false,
            menuList: ['营销', '优惠券领取'],
            title: '加载中',
            rules: {
                uid: [{
                    required: true,
                    message: '用户id不能为空',
                    trigger: 'blur'
                },
                {
                    pattern: '^[0-9]*$',
                    message: "只能输入数字"
                }],
                coupon_ids: [{
                    required: true,
                    message: '优惠券id不能为空',
                    trigger: 'blur',
                },
                {
                    pattern: '^(\\d+,?)+$',
                    message: "请输入数字id,逗号分割"
                }
                ],
            },
            pageInfo: {
            },
            queryParams: {
                page: 1,
                pagesize: 10,
            },
            confirmContent: '',
            confirmVisible: false,
            forms: {},
        };
    },
    created() {
        this.loadData()
    },
    methods: {
        //优惠券列表
        loadData() {
            this.loading = true;
            request.get('/coupon/user/detailed', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.ctime = deal.timestamp(val.ctime, 'unix');
                        val.stime = deal.timestamp(val.stime, 'unix');
                        return val;
                    });

                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //发券
        giveCoupon() {
            this.show = true;
            if (this.$refs.forms) {
                this.$refs.forms.resetFields()
            }
        },
        toggleAdd(val) {
            this.addVisibles = val
        },
        getAddGood(val) {
            if (val) {
                let ids = []
                ids = val.map(item =>
                    item.id
                )
                console.log(44444, ids)
                this.forms.coupon_ids = ids.join(',')
            }
        },
        give() {
            if (this.$refs.forms) {
                this.$refs.forms.validate(valid => {
                    if (valid) {
                        request.post('/coupon/give/coupon/add', this.forms).then(ret => {
                            if (ret.code == 1) {
                                this.show = false;
                                this.loadData();
                                this.$message.success('送券成功');
                            } else {
                                this.$message.error(ret.msg);
                            }

                        });
                    } else {
                        this.$message.error('请补全信息');

                        return false;
                    }

                });
            };
        },

        // 状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否修改状态为已使用?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },

        // 分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            this.loadData()
        },
        // 确定下线
        stateData() {
            request.post('/coupon/user/edit', this.form).then(ret => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
/* 选择链接样式 */
.dialog_box .el-button {
    margin-left: 20px;
}
</style>